<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h1>Fort Mart</h1>
            <p>Innovation in Sri Lankan Wholesale &amp; Retail</p>
        </div>
    </div>
</div>

<section class="about-area ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="about-content">
                    <span class="sub-title">Our Investment</span>
                    <h2>Driving Innovation in Sri Lankan Wholesale &amp; Retail</h2>
                    <p>Fort Mart is a company Webstazy One holds a stake in, focused on bringing technology-led innovation to Sri Lanka's wholesale and retail industry. Fort Mart is building intelligent solutions that modernise how businesses manage inventory, serve customers, and grow sales across physical and digital storefronts.</p>
                    <p>From smart point-of-sale systems to real-time analytics dashboards, Fort Mart equips wholesalers and retailers across Sri Lanka with the tools they need to compete in a rapidly evolving marketplace.</p>
                    <p>Webstazy One is proud to support Fort Mart's mission to bridge the gap between traditional commerce and modern technology — making enterprise-grade retail solutions accessible to Sri Lankan businesses of every scale.</p>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="fm-showcase wow fadeInUp" data-wow-delay=".2s" aria-hidden="true">
                    <span class="fm-showcase-label">The Fort Mart platform</span>
                    <div class="fm-showcase-grid">
                        <div class="fm-showcase-card">
                            <i class="bx bx-store"></i>
                            <span>Point of Sale</span>
                        </div>
                        <div class="fm-showcase-card">
                            <i class="bx bx-package"></i>
                            <span>Inventory</span>
                        </div>
                        <div class="fm-showcase-card">
                            <i class="bx bx-line-chart"></i>
                            <span>Analytics</span>
                        </div>
                        <div class="fm-showcase-card">
                            <i class="bx bx-cart"></i>
                            <span>E-Commerce</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="features-card-section ptb-100 bg-f8fbfa">
    <div class="container">
        <div class="section-title">
            <h2>Our Solutions</h2>
            <p>An integrated retail platform that connects the counter, the stockroom and the online storefront.</p>
        </div>
        <div class="row">
            <div class="col-lg-4 col-sm-6 col-md-6">
                <div class="single-features-card tx-center wow fadeInUp" data-wow-delay=".2s">
                    <i class="bx bx-store" aria-hidden="true"></i>
                    <h3>Smart POS Systems</h3>
                    <p>Fast, reliable point-of-sale built for busy counters — barcode scanning, flexible payments and billing that keeps queues moving.</p>
                </div>
            </div>
            <div class="col-lg-4 col-sm-6 col-md-6">
                <div class="single-features-card tx-center wow fadeInUp" data-wow-delay=".3s">
                    <i class="bx bx-package" aria-hidden="true"></i>
                    <h3>Inventory Management</h3>
                    <p>Track stock across warehouses and branches in real time, with reorder points and supplier records kept in one place.</p>
                </div>
            </div>
            <div class="col-lg-4 col-sm-6 col-md-6">
                <div class="single-features-card tx-center wow fadeInUp" data-wow-delay=".4s">
                    <i class="bx bx-line-chart" aria-hidden="true"></i>
                    <h3>Customer Analytics</h3>
                    <p>Turn everyday transactions into readable dashboards: what sells, when it sells, and which customers keep coming back.</p>
                </div>
            </div>
            <div class="col-lg-4 col-sm-6 col-md-6">
                <div class="single-features-card tx-center wow fadeInUp" data-wow-delay=".5s">
                    <i class="bx bx-cart" aria-hidden="true"></i>
                    <h3>E-Commerce Integration</h3>
                    <p>One catalogue, one stock pool. Physical shelves and online storefronts stay in sync on orders, pricing and availability.</p>
                </div>
            </div>
            <div class="col-lg-4 col-sm-6 col-md-6">
                <div class="single-features-card tx-center wow fadeInUp" data-wow-delay=".6s">
                    <i class="bx bx-cloud" aria-hidden="true"></i>
                    <h3>Cloud Infrastructure</h3>
                    <p>Hosted on cloud-based infrastructure, so branches stay connected, data stays backed up, and the platform scales with the business.</p>
                </div>
            </div>
            <div class="col-lg-4 col-sm-6 col-md-6">
                <div class="single-features-card tx-center wow fadeInUp" data-wow-delay=".7s">
                    <i class="bx bx-trending-up" aria-hidden="true"></i>
                    <h3>Demand Forecasting</h3>
                    <p>AI-driven forecasting reads sales history and seasonality to suggest what to stock before the shelves run dry.</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="fm-cta-area ptb-100">
    <div class="container">
        <div class="contact-cta-box mwidth-1000 wow fadeInUp" data-wow-delay=".2s">
            <h3>Interested in Fort Mart?</h3>
            <p>Get in touch to learn more about our investment in Fort Mart and how they are transforming retail in Sri Lanka.</p>
            <a routerLink="/contact" class="default-btn"><i class="bx bxs-hot" aria-hidden="true"></i>Get in Touch<span></span></a>
        </div>
    </div>
    <div class="shape-map1" aria-hidden="true"><img loading="lazy" decoding="async" src="assets/img/map1.png" alt=""></div>
    <div class="shape7" aria-hidden="true"><img loading="lazy" decoding="async" src="assets/img/shape/shape7.png" alt=""></div>
    <div class="shape8" aria-hidden="true"><img loading="lazy" decoding="async" src="assets/img/shape/shape8.png" alt=""></div>
    <div class="shape9" aria-hidden="true"><img loading="lazy" decoding="async" src="assets/img/shape/shape9.png" alt=""></div>
</section>

<section class="faq-area ptb-100">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="col-lg-7 col-md-12">
                <div class="faq-accordion">
                    <h2>Get to know <span>Fort Mart</span></h2>
                    <div class="accordion" id="fmAccordion">
                        <div class="card">
                            <div class="card-header" role="heading" aria-level="3" id="fmHeadingOne">
                                <button class="fm-accordion-btn" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#fmCollapseOne" aria-expanded="true" aria-controls="fmCollapseOne">
                                    What is Fort Mart? <i class="bx bx-plus" aria-hidden="true"></i>
                                </button>
                            </div>
                            <div id="fmCollapseOne" class="collapse show" aria-labelledby="fmHeadingOne"
                                data-bs-parent="#fmAccordion">
                                <div class="card-body">
                                    Fort Mart is a Sri Lankan company focused on retail and wholesale technology innovation. Webstazy One is a part-owner of Fort Mart, supporting their mission to equip local businesses with smart POS systems, inventory management, customer analytics, and seamless e-commerce integration.
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" role="heading" aria-level="3" id="fmHeadingTwo">
                                <button class="fm-accordion-btn collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#fmCollapseTwo" aria-expanded="false" aria-controls="fmCollapseTwo">
                                    Who can benefit from Fort Mart? <i class="bx bx-plus" aria-hidden="true"></i>
                                </button>
                            </div>
                            <div id="fmCollapseTwo" class="collapse" aria-labelledby="fmHeadingTwo"
                                data-bs-parent="#fmAccordion">
                                <div class="card-body">
                                    Fort Mart is built for retailers of all sizes — from independent stores and boutiques to large retail chains looking to streamline operations and enhance customer experiences through technology.
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" role="heading" aria-level="3" id="fmHeadingThree">
                                <button class="fm-accordion-btn collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#fmCollapseThree" aria-expanded="false" aria-controls="fmCollapseThree">
                                    What technologies does Fort Mart use? <i class="bx bx-plus" aria-hidden="true"></i>
                                </button>
                            </div>
                            <div id="fmCollapseThree" class="collapse" aria-labelledby="fmHeadingThree"
                                data-bs-parent="#fmAccordion">
                                <div class="card-body">
                                    Fort Mart leverages cloud-based infrastructure, real-time data analytics, AI-driven demand forecasting, and modern web technologies to deliver a robust and scalable retail management platform.
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" role="heading" aria-level="3" id="fmHeadingFour">
                                <button class="fm-accordion-btn collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#fmCollapseFour" aria-expanded="false" aria-controls="fmCollapseFour">
                                    Does Fort Mart support e-commerce? <i class="bx bx-plus" aria-hidden="true"></i>
                                </button>
                            </div>
                            <div id="fmCollapseFour" class="collapse" aria-labelledby="fmHeadingFour"
                                data-bs-parent="#fmAccordion">
                                <div class="card-body">
                                    Yes. Fort Mart provides seamless integration between physical stores and online storefronts, enabling unified inventory, order management, and customer data across all channels.
                                </div>
                            </div>
                        </div>
                        <div class="card mb-0">
                            <div class="card-header" role="heading" aria-level="3" id="fmHeadingFive">
                                <button class="fm-accordion-btn collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#fmCollapseFive" aria-expanded="false" aria-controls="fmCollapseFive">
                                    How do I get started with Fort Mart? <i class="bx bx-plus" aria-hidden="true"></i>
                                </button>
                            </div>
                            <div id="fmCollapseFive" class="collapse" aria-labelledby="fmHeadingFive"
                                data-bs-parent="#fmAccordion">
                                <div class="card-body">
                                    Simply reach out to our team through the contact page. We will schedule a demo, understand your retail needs, and tailor a solution that fits your business.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-5 col-md-12">
                <div class="faq-image wow fadeInUp" data-wow-delay=".2s">
                    <img loading="lazy" decoding="async" src="assets/img/getToKnow.jpg" alt="Colleagues collaborating around a desk of laptops and notebooks">
                </div>
            </div>
        </div>
    </div>
</section>

<section class="free-trial-area ptb-100 bg-f4f5fe">
    <div class="container">
        <div class="free-trial-content">
            <h2>Sri Lanka's retail future is being built today</h2>
            <p>Fort Mart is leading the charge in wholesale and retail innovation across Sri Lanka</p>
            <a routerLink="/contact" class="default-btn"><i class="bx bxs-hot" aria-hidden="true"></i>Get in Touch<span></span></a>
        </div>
    </div>
    <div class="shape10" aria-hidden="true"><img loading="lazy" decoding="async" src="assets/img/shape/shape10.png" alt=""></div>
    <div class="shape11" aria-hidden="true"><img loading="lazy" decoding="async" src="assets/img/shape/shape7.png" alt=""></div>
    <div class="shape12" aria-hidden="true"><img loading="lazy" decoding="async" src="assets/img/shape/shape11.png" alt=""></div>
    <div class="shape13" aria-hidden="true"><img loading="lazy" decoding="async" src="assets/img/shape/shape12.png" alt=""></div>
</section>
